import React from 'react';
import styled from 'styled-components/macro';
import { Search, Dropdown } from 'lib/components';

import { VerificationStatusOptions } from 'lib/const/VerificationsStatusOptions';
import { ResellersDropdown } from './ResellersDropdown';

const FiltersContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  width: 100%;
  justify-content: space-between;
`;

type FilterProps = {
  marginRight?: number;
  width?: number;
};
const Filter = styled.div<FilterProps>`
  min-width: 224px;
  width: ${props => `${props.width}px` || 'auto'};
  margin-right: ${props => `${props.marginRight}px` || '0px'};
`;

type Props = {
  prevSearch?: string;
  statusFilter?: number;
  resellerFilter?: number;
  showResellerFilter?: boolean;
  onSelectStatus(statusValue: number): void;
  onSelectReseller(resellerId: number): void;
  onSearch(search: string): void;
  showResellerDropdown?: boolean;
};

export const SearchAndFilter = ({
  prevSearch,
  statusFilter,
  resellerFilter,
  showResellerFilter,
  onSelectStatus,
  onSelectReseller,
  onSearch,
  showResellerDropdown = true,
}: Props) => {
  return (
    <FiltersContainer>
      <Filter width={536} marginRight={12}>
        <Search
          placeholder='Search by business name, id, admin name or email...'
          onSearch={onSearch}
          prevSearch={prevSearch}
        />
      </Filter>

      <Filter width={224} marginRight={showResellerDropdown ? 12 : 270}>
        <Dropdown
          menuPortalTarget={document.body}
          zIndexProp={1}
          menuPlacement={'bottom'}
          height={40}
          creatable={false}
          className='dropdown'
          placeholder={'Filter by Statuses'}
          value={VerificationStatusOptions.find(
            option => option.value === statusFilter
          )}
          onChange={value => onSelectStatus(value.value)}
          options={VerificationStatusOptions}
        />
      </Filter>
      <Filter width={224}>
        {showResellerFilter && (
          <ResellersDropdown
            zIndexProp={1}
            showAllResellerOption={true}
            resellerFilter={resellerFilter}
            onSelectReseller={onSelectReseller}
          />
        )}
      </Filter>
    </FiltersContainer>
  );
};
